import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Form,  Container, Row, Col, Card, Image, Navbar } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useAuth } from "../../hooks/useAuth";
import { loginAction } from "../../redux-store/actions/authActions";
import { toast } from 'react-toastify';

export const Login = () => {

  const { login } = useAuth();
  const dispatch = useDispatch();
  const { register, handleSubmit,formState: { errors } } = useForm();

  const [loading, setLoading] = useState(false);
  
  const onSubmit = (formValue) => {

    const { UserName, Password } = formValue;
    setLoading(true);

    dispatch(loginAction({UserName, Password}))
      .then((data) => {
        setLoading(false);
        if (data.payload.hasError) {
            toast.error(data.payload.errors[0].message, {
            position: "top-center",
            toastId: "login-error"
          });
        }
        else {
          login(data.payload.data);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const documentHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty('--doc-height', `${window.innerHeight}px`)
   }
 
   useEffect(()=>{
    window.addEventListener("resize", documentHeight);
    documentHeight();
 },[])


  return (
    <div className="login-page">
      <Container fluid>
        <Row className="d-flex min-vh-100 align-items-start align-items-md-center">
          <Col></Col>
          <Col md={6} lg={4}>
            <Navbar.Brand as="li" className="d-block text-center login-logo mb-4">
            <Image src={`${process.env.PUBLIC_URL}/images/logo_login.png`} className="logo-img" />
            </Navbar.Brand>
            <div className="d-flex justify-content-center">
              <Card className="login-card">
                <Card.Header className="text-uppercase fw-bold login-card-header">
                  login
                </Card.Header>
                <Card.Body>
                  <div>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                      <Row>
                        <Form.Group as={Col} md="12" className="mb-3">
                          <Form.Control
                            type="text"
                            name="username"

                            {...register('UserName', { required: true })}
                            className={`${errors.UserName ? 'is-invalid' : ''}`} placeholder="Username"
                          />
                        </Form.Group>
                        <Form.Group as={Col} md="12" className="mb-3">

                          <Form.Control
                            type="password"
                            name="password"

                            {...register("Password", { required: true })}
                            placeholder="Password"
                            className={`${errors.Password ? 'is-invalid' : ''}`}
                          />
                        </Form.Group>
                      </Row>
                      <button
                        type="submit"
                        className="btn btn-primary btn-block btn-card-footer float-end"
                        disabled={loading}
                      >
                        {loading && (
                          <span className="spinner-border spinner-border-sm"></span>
                        )}
                        <span> Login</span>
                      </button>

                    </Form>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;